/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { EntryPointContainer, type EntryPoint, type EntryPointComponent } from 'react-relay';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { REDIRECT } from '@jira/platform__entry-points-page-layout-fields/src/index.tsx';
import { usePageLayoutEntryPoint } from '@jira/platform__entry-points-page-layout-entry-point/src/index.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { EntryPointReferencePlaceholder } from '@jira/platform__entry-points-point-placeholder';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

export const RedirectEntrypointContainer = (): React.JSX.Element | null => {
	const redirectEntrypointRef =
		usePageLayoutEntryPoint<
			EntryPoint<
				EntryPointComponent<{}, {}, {}, { fallback: () => JSX.Element | undefined }>,
				{ fallback: () => JSX.Element | undefined }
			>
		>(REDIRECT);

	if (!redirectEntrypointRef) return null;

	return (
		<UFOSegment name="redirect-entrypoint">
			<JSErrorBoundary fallback="unmount" id="redirect-entrypoint" packageName="page-container">
				<EntryPointReferencePlaceholder
					name="redirect-entrypoint"
					fallback={null}
					entryPointReference={redirectEntrypointRef}
				>
					<EntryPointContainer entryPointReference={redirectEntrypointRef} props={{}} />
				</EntryPointReferencePlaceholder>
			</JSErrorBoundary>
		</UFOSegment>
	);
};
